// extracted by mini-css-extract-plugin
export default {"audioRecorder":"audioRecorder___e7f2f3bd6ae7f696","controls":"controls___fde9fd482999d930","center":"center___fcf1eb57b3f89356"};